<template>
  <v-flex>
    <v-card :color="'rgb(250, 250, 250)'" class="elevation-2">
      <v-toolbar dense :color="colorBarraFormulario" dark flat>
        <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
          <span v-bind:style="{ color: 'white' }">{{ 'Datos Fiscales de ' + modelProveedor.nombre }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarProveedor(false)">
          <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
          <span v-else v-bind:style="{ color: 'white' }">Guardar</span>
        </v-chip>
        <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarProveedor(true)">
          <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
          <span v-else v-bind:style="{ color: 'white' }">Guardar y Cerrar</span>
        </v-chip>
        <v-icon size="30" :color="'white'" @click="_cerrarVentana">mdi-close-circle</v-icon>
      </v-toolbar>

      <v-container class="mt-8 px-4 pt-4 pb-4">
        <v-row>
          <v-col>
          <v-row dense class="mx-4">
            <v-text-field v-model="modelProveedor.nombre" outlined label="Nombre" dense :dark="dark"
              autocomplete="off"></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field outlined v-model="modelProveedor.email_administracion" :dark="dark" label="Email de Administración" dense
              autocomplete="off"></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field outlined v-model="modelProveedor.telefono_administracion" :dark="dark" label="Teléfono de Administración" dense
              autocomplete="off"></v-text-field>
          </v-row>
          
          <v-row dense class="mx-4">
            <v-text-field outlined v-model="modelProveedor.banco_iban" :dark="dark" label="IBAN" dense
              autocomplete="off"></v-text-field>
          </v-row>
          <v-row dense class="mx-4">
            <v-text-field outlined v-model="modelProveedor.direccion_fiscal" :dark="dark" label="Dirección" dense
              autocomplete="off"></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field outlined v-model="modelProveedor.cod_postal_fiscal" :dark="dark" label="Codigo Postal" dense
              autocomplete="off"></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field outlined v-model="modelProveedor.cod_postal_internacional" :dark="dark" label="Codigo Postal Internacional" dense
              autocomplete="off"></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field outlined v-model="modelProveedor.poblacion_fiscal" :dark="dark" label="Población" dense
              autocomplete="off"></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field outlined v-model="modelProveedor.provincia_fiscal" :dark="dark" label="Provincia" dense
              autocomplete="off"></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field outlined v-model="modelProveedor.pais_fiscal" :dark="dark" label="País" dense
              autocomplete="off"></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field outlined v-model="modelProveedor.modalidad_pago" :dark="dark" label="Modalidad de Pago" dense
              autocomplete="off"></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field outlined v-model="modelProveedor.forma_pago" :dark="dark" label="Forma de Pago" dense
              autocomplete="off"></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field outlined v-model="modelProveedor.titulo" :dark="dark" label="Titulo" dense
              autocomplete="off"></v-text-field>
          </v-row>
          
          <v-row dense class="mx-4">
            <v-text-field outlined v-model="modelProveedor.mensaje_alerta" :dark="dark" label="Mensaje de Alerta" dense
              autocomplete="off"></v-text-field>
          </v-row>




          </v-col>

        </v-row>

      </v-container>

    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "ProveedorFormulario",
  components: {},
  data: () => ({
    loading: false,
   
    dialogFormularioCalendarioTarifas: false,


  }),

  props: {
    modelProveedor: {
      type: Object,
      required: true,
    },

    accion: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorBarraFormulario",
      "colorFondoDialog",
      "tiposProveedor",

    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("proveedores", [
      "regimenes",
      "categoriasProveedor",
      "tiposHabitacion",
      "caracteristicasHabitacion",
      "puntosProveedores",
    ]),



  },

  watch: {
   
  },

  mounted() {
   
  },

  methods: {
    ...mapActions("proveedores", ["getProveedores", "crearProveedor", "updateProveedorDatosFiscales"]),
    ...mapActions("puntos", ["getPuntos"]),

    _cerrarVentana() {
      this.$emit("cerrarFormularioDatosFiscales");
    },

    _openGestionCalendarioTarifas() {

      this.dialogFormularioCalendarioTarifas = true;
    },

   
    async _guardarProveedor(cierre) {
      this.loading = true;
      if (this.accion == "editar") {
        var res = await this.updateProveedorDatosFiscales([
          this.access_token,
          this.modelProveedor,
        ]);
        if (cierre) {
          this._cerrarVentana();
        }
      }
      this.loading = false;
    },
  },
};
</script>
